import PropTypes from 'prop-types'

export default {
  size: PropTypes.oneOf(['large', 'medium', 'small', 'tiny']),
}
